import { FACEBOOK, YOUTUBE, INSTAGRAM, TWITTER, TIKTOK, VIDEO, IMAGE, TEXT, TELEGRAM } from './static-configuration';

export function extractAssetURLData(assetURL) {
  const twitterId = extractTwitterStatusId(assetURL);
  if (twitterId) {
    return {
      platform: TWITTER,
      assetType: TEXT, // TODO we should determine what they are  really
      assetId: twitterId,
      assetURL,
    };
  }

  const youtubeId = extractYoutubeVideoID(assetURL);
  if (youtubeId) {
    return {
      platform: YOUTUBE,
      assetType: VIDEO,
      assetId: youtubeId,
      assetURL: `https://www.youtube.com/watch?v=${youtubeId}`,
    };
  }

  const facebookVideoData = extractFacebookVideoID(assetURL);
  if (facebookVideoData) {
    return {
      platform: FACEBOOK,
      assetType: VIDEO,
      assetId: facebookVideoData.id,
      assetURL: `https://www.facebook.com/${facebookVideoData.owner}/videos/${facebookVideoData.id}/`,
    };
  }

  const facebookPhotoData = extractFacebookPhotoID(assetURL);
  if (facebookPhotoData) {
    return {
      platform: FACEBOOK,
      assetType: IMAGE,
      assetId: facebookPhotoData.id,
      assetURL: `https://www.facebook.com/${facebookPhotoData.owner}/photos/${facebookPhotoData.id}/`,
    };
  }

  const facebookPostData = extractFacebookPostID(assetURL);
  if (facebookPostData) {
    return {
      platform: FACEBOOK,
      assetType: TEXT,
      assetId: facebookPostData.id,
      assetURL: `https://www.facebook.com/${facebookPostData.owner}/posts/${facebookPostData.id}/`,
    };
  }

  const instagramId = extractInstagramID(assetURL);
  if (instagramId) {
    return {
      platform: INSTAGRAM,
      assetType: IMAGE, // TODO this may not be correct
      assetId: instagramId,
      assetURL: `https://www.instagram.com/p/${instagramId}/`,
    };
  }

  const tiktokResult = extractTiktokID(assetURL);
  if (tiktokResult) {
    const { tiktokHandle, tiktokId } = tiktokResult;
    return {
      platform: TIKTOK,
      assetType: VIDEO, // TODO this may not be correct
      assetId: tiktokId,
      handle: tiktokHandle,
      assetURL: `https://www.tiktok.com/@${tiktokHandle}/video/${tiktokId}/`,
    };
  }

  // https://t.me/gembaba/308847
  const telegramResult = extractTelegramID(assetURL);
  if (telegramResult) {
    const { telegramHandle, telegramId } = telegramResult;
    return {
      platform: TELEGRAM,
      assetType: TEXT, // TODO this may not be correct
      assetId: `${telegramHandle}/${telegramId}`,
      handle: telegramHandle,
      assetURL: `https://t.me/${telegramHandle}/${telegramId}`,
    };
  }

  return null;
}

export function extractTwitterStatusId(url) {
  if (!url) return null;
  const regEx = /status\/(\d*)(\/?)$/;
  const match = url.match(regEx);
  return match ? match[1] : null;
}

export function extractYoutubeVideoID(url) {
  if (!url || !url.match(/youtu/)) return null;
  const regExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length == 11) ? match[2] : null;
}

export function extractFacebookVideoID(url) {
  if (!url || !url.match(/facebook/)) return null;
  const regExp = /^http(?:s?):\/\/(?:www\.|web\.|m\.)?facebook\.com\/([A-z0-9\.]+)\/videos(?:\/[0-9A-z].+)?\/(\d+)(?:.+)?$/;
  const match = url.match(regExp);
  return (match) ? { id: match[2], owner: match[1] } : null;
}

export function extractFacebookPhotoID(url) {
  if (!url || !url.match(/facebook/)) return null;
  const regExp = /^http(?:s?):\/\/(?:www\.|web\.|m\.)?facebook\.com\/([A-z0-9\.]+)\/photos(?:\/[0-9A-z].+)?\/(\d+)(?:.+)?$/;
  // https://www.facebook.com/ginaisfunny/photos/a.386636203612.165877.29074218612/10155268288808613/?type=3
  const match = url.match(regExp);
  return (match) ? { id: match[2], owner: match[1] } : null;
}

export function extractFacebookPostID(url) {
  if (!url || !url.match(/facebook/)) return null;
  const regExp = /^http(?:s?):\/\/(?:www\.|web\.|m\.)?facebook\.com\/([A-z0-9\.]+)\/posts(?:\/[0-9A-z].+)?\/(\d+)(?:.+)?$/;
  // https://www.facebook.com/ginaisfunny/photos/a.386636203612.165877.29074218612/10155268288808613/?type=3
  const match = url.match(regExp);
  return (match) ? { id: match[2], owner: match[1] } : null;
}

export function extractTiktokID(url) {
  if (!url) return null;
  if (!url.match(/tiktok/)) return null;
  const regExp = /^http(?:s?):\/\/(?:www\.|web\.|m\.)?tiktok\.com\/\@([A-z0-9\.]+)\/video(?:\/[0-9A-z].+)?\/(\d+)(?:.+)?$/;
  // https://www.tiktok.com/@therock/video/6879854011848150277?lang=en&is_copy_url=1&is_from_webapp=v1
  const match = url.match(regExp);
  return (match) ? { tiktokHandle: match[1], tiktokId: match[2] } : null;
}

export function extractInstagramID(url) {
  if (!url || !url.match(/instagram/)) return null;
  const regExp = /https?:\/\/[w\.]*instagram\.[^\/]*\/([^?]*)\/([a-zA-Z0-9_-]{1,11})/;
  const match = url.match(regExp);
  return (match) ? match[2] : null;
}

export function extractTelegramID(url) {
  if (!url) return null;
  const regExp = /https:\/\/t.me\/(.*)\/(\d*)/;
  const match = url.match(regExp);
  return (match) ? { telegramHandle: match[1], telegramId: match[2] } : null;
}



/** WEBPACK FOOTER **
 ** ./src/utils/asset-url-helper-service.js
 **/